import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Box, Card, CardContent, CircularProgress, Container, Typography } from '@mui/material';
import api from '../services/api';

export const PublicTracePage: React.FC = () => {
  const { batchId } = useParams<{ batchId: string }>();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [data, setData] = useState<any | null>(null);

  useEffect(() => {
    const load = async () => {
      if (!batchId) {
        setError('Identificador de lote inválido');
        setLoading(false);
        return;
      }
      try {
        setLoading(true);
        const res = await api.getPublicTrace(batchId);
        setData(res);
        setError(null);
      } catch (e: any) {
        setError('No se encontró información de trazabilidad para este lote.');
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [batchId]);

  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      {loading && (
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mt: 6 }}>
          <CircularProgress />
          <Typography variant="body2" sx={{ mt: 2 }}>Cargando trazabilidad...</Typography>
        </Box>
      )}
      {!loading && error && (
        <Typography variant="body1" color="error">{error}</Typography>
      )}
      {!loading && !error && data && (
        <Box>
          <Typography variant="h5" gutterBottom>Trazabilidad del lote</Typography>
          <Typography variant="subtitle1">
            Producto: {data.productName} ({data.sku})
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Lote: {data.batchCode || data.batchPublicId}{data.producedAt ? ` · Producido: ${new Date(data.producedAt).toLocaleString()}` : ''}
          </Typography>

          {(data.components || []).length === 0 && (
            <Typography variant="body2" color="text.secondary" sx={{ mt: 3 }}>
              No hay componentes registrados para este lote.
            </Typography>
          )}

          {(data.components || []).map((c: any, idx: number) => (
            <Card key={idx} sx={{ mt: 2 }}>
              <CardContent>
                <Typography variant="subtitle2">
                  [{c.type}] {c.name}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Cantidad requerida: {c.quantityRequired}
                </Typography>
                {(c.batches || []).length > 0 && (
                  <Box sx={{ mt: 1 }}>
                    <Typography variant="body2" fontWeight={600}>Lotes asociados:</Typography>
                    {(c.batches || []).map((b: any, j: number) => (
                      <Typography key={j} variant="body2" color="text.secondary">
                        - {b.lotCode || b.batchPublicId} (qty {b.quantityUsed}
                        {b.supplierName ? ` · Proveedor: ${b.supplierName}` : ''}
                        {b.purchaseReference ? ` · Ref: ${b.purchaseReference}` : ''}
                        {b.expirationDate ? ` · Vence: ${new Date(b.expirationDate).toLocaleDateString()}` : ''}
                        )
                      </Typography>
                    ))}
                  </Box>
                )}
              </CardContent>
            </Card>
          ))}
        </Box>
      )}
    </Container>
  );
};

